import { PRODUCT_CURRENCY_DETAILS } from "../../types/ProductCurrencyType";
import axios from "axios";

const detailProductCurrency = (data) => {
	return {
		type: PRODUCT_CURRENCY_DETAILS,
		payload: data,
	};
};

export const loadSingleProductCurrency = (id) => {
	//dispatching with an call back function and returning that
	return async (dispatch) => {
		try {
			const data = await axios.get(`product-currency/${id}`);
			//dispatching data
			dispatch(detailProductCurrency(data));
			return data;
		} catch (error) {
			console.log(error.message);
		}
	};
};
